import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";
import { FC } from "react";

interface AuthCardLastUsedBadgeProps {
  className?: string;
}

export const AuthCardLastUsedBadge: FC<AuthCardLastUsedBadgeProps> = observer(({ className }) => {
  return <StyledBadge className={className}>Last used</StyledBadge>;
});

const StyledBadge = styled.span`
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  padding: 0 ${({ theme }) => theme.spacing["1"]};
  border-radius: 4px;
  white-space: nowrap;
  user-select: none;
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  line-height: ${({ theme }) => theme.lineHeights["text-s"]};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  color: ${({ theme }) => theme.colors.text.emphasis};
  background: ${({ theme }) => theme.colors.background.badge.emphasis};
  pointer-events: none;
`;
